import { useAtom } from '@reatom/npm-react'
import React from 'react'
import styled from 'styled-components'

import { createIcon, useHapticFeedback } from '@blade/ui-kit'

import { walletsExpandedAtom } from '../atoms'

import type { ClassNameProps } from '@root/shared/react'

type WalletsSwitchProps = ClassNameProps

export const WalletsSwitch: React.FC<WalletsSwitchProps> = ({ className }) => {
  const [expanded, setExpanded] = useAtom(walletsExpandedAtom)
  const haptics = useHapticFeedback()

  const handleExpandedChange = (nextValue: boolean) => {
    if (expanded !== nextValue) {
      haptics.impactOccurred('light')
      setExpanded(nextValue)
    }
  }

  return (
    <Root className={className}>
      <Item
        data-active={!expanded}
        onClick={() => {
          handleExpandedChange(false)
        }}
      >
        <CollapsedIcon size={16} />
      </Item>
      <Item
        data-active={expanded}
        onClick={() => {
          handleExpandedChange(true)
        }}
      >
        <ExpandedIcon size={16} />
      </Item>
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  border-radius: 24px;
  background-color: var(--backgroundA-2);
  padding: 2px;
  position: relative;
`

const Item = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;

  color: var(--backgroundA-9);
  &[data-active='true'] {
    background-color: var(--backgroundA-5);
    color: var(--background-12);
  }
  transition: all 0.15s linear;
  position: relative;
`

const CollapsedIcon = createIcon(
  <>
    <path
      d="M2 3.5C2 3.22386 2.22386 3 2.5 3H13.5C13.7761 3 14 3.22386 14 3.5V4.5C14 4.77614 13.7761 5 13.5 5H2.5C2.22386 5 2 4.77614 2 4.5V3.5Z"
      fill="currentColor"
    />
    <path
      d="M2 7.5C2 7.22386 2.22386 7 2.5 7H13.5C13.7761 7 14 7.22386 14 7.5V8.5C14 8.77614 13.7761 9 13.5 9H2.5C2.22386 9 2 8.77614 2 8.5V7.5Z"
      fill="currentColor"
    />
    <path
      d="M2.5 11C2.22386 11 2 11.2239 2 11.5V12.5C2 12.7761 2.22386 13 2.5 13H13.5C13.7761 13 14 12.7761 14 12.5V11.5C14 11.2239 13.7761 11 13.5 11H2.5Z"
      fill="currentColor"
    />
  </>,
  '0 0 16 16',
)

const ExpandedIcon = createIcon(
  <>
    <path
      d="M2.5 4C2.22386 4 2 4.22386 2 4.5V6.5C2 6.77614 2.22386 7 2.5 7H13.5C13.7761 7 14 6.77614 14 6.5V4.5C14 4.22386 13.7761 4 13.5 4H2.5Z"
      fill="currentColor"
    />
    <path
      d="M2.5 9C2.22386 9 2 9.22386 2 9.5V11.5C2 11.7761 2.22386 12 2.5 12H13.5C13.7761 12 14 11.7761 14 11.5V9.5C14 9.22386 13.7761 9 13.5 9H2.5Z"
      fill="currentColor"
    />
  </>,
  '0 0 16 16',
)
